const collaborationStatus = {
  en: {
    collaborationStatus: {
      expired: "Expired",
      checking: "Checking...",
      available: "Available",
      editing: "Editing ({{time}})",
      lockedBy: "Locked by {{name}}",
      checkingLock: "Checking lock...",
      youAreEditingTime: "You are editing • {{time}}",
      release: "Release",
      availableForEditingShort: "Available for editing",
      lock: "Lock",
      refreshStatus: "Refresh status",
      checkingStatus: "Checking collaboration status...",
      availableForEditing: "Available for Editing",
      noOneEditing: "No one is currently editing this result. Acquire a lock to begin editing.",
      refresh: "Refresh",
      startEditing: "Start Editing",
      youAreEditing: "You are Editing",
      lockExpiresIn: "Lock expires in:",
      autoExtends: "(Lock auto-extends while editing)",
      releaseLock: "Release Lock",
      resultLocked: "Result is Locked",
      currentlyEditedBy: "Currently being edited by:",
      checkAgain: "Check Again",
      waitUntil: "Please wait until the lock expires or is released before editing."
    }
  },
  fr: {
    collaborationStatus: {
      expired: "Expiré",
      checking: "Vérification...",
      available: "Disponible",
      editing: "Modification en cours ({{time}})",
      lockedBy: "Verrouillé par {{name}}",
      checkingLock: "Vérification du verrou...",
      youAreEditingTime: "Vous modifiez • {{time}}",
      release: "Libérer",
      availableForEditingShort: "Disponible pour modification",
      lock: "Verrouiller",
      refreshStatus: "Actualiser le statut",
      checkingStatus: "Vérification du statut de collaboration...",
      availableForEditing: "Disponible pour modification",
      noOneEditing: "Personne ne modifie actuellement ce résultat. Acquérez un verrou pour commencer la modification.",
      refresh: "Actualiser",
      startEditing: "Commencer la modification",
      youAreEditing: "Vous êtes en train de modifier",
      lockExpiresIn: "Le verrou expire dans :",
      autoExtends: "(Le verrou se prolonge automatiquement pendant la modification)",
      releaseLock: "Libérer le verrou",
      resultLocked: "Le résultat est verrouillé",
      currentlyEditedBy: "Actuellement modifié par :",
      checkAgain: "Vérifier à nouveau",
      waitUntil: "Veuillez attendre que le verrou expire ou soit libéré avant de modifier."
    }
  }
};

export default collaborationStatus;
